import React from 'react';

export const IconArrowRightCircle = props => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M22 12C22 6.48 17.52 2 12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12ZM12 13H8V11H12V8L16 12L12 16V13Z"
      fill="#502314"
    />
  </svg>
);
